import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Path, { ProtectedRoutes, PublicRoutes } from "./LocalRoutes";
import PolicyPage from "../modules/Common/PolicyPage/PolicyPage";
import DeleteAccountPage from "../modules/Common/DeleteAccountPage/DeleteAccountPage";
import ProtectedRoute from "./ProtectedRoute";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { onboardingRoute } from "../features/onboarding/routes";
import { ONBOARDING_BASE_PATH } from "../features/onboarding/steps/registry";
import { isSignupDeepLink, signupEntryPath } from "./signupDeepLink";

export const RootRedirect = () => {
  const { search } = useLocation();

  return (
    <Navigate
      to={
        isSignupDeepLink(search)
          ? signupEntryPath(ONBOARDING_BASE_PATH)
          : Path.Signin
      }
      replace
    />
  );
};

let stripePromise;

const StripeElements = ({ children }) => {
  stripePromise ??= loadStripe(`${import.meta.env.VITE_STRIPE_KEY}`);
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

const Router = () => {
  const location = useLocation();

  return (
    <>
      <Routes location={location} key={location.pathname}>
        {PublicRoutes.map((itm) => (
          <Route key={itm.path} element={itm.element} path={itm.path} />
        ))}
        {ProtectedRoutes.map((item) => (
          <Route
            key={item.path}
            element={
              <ProtectedRoute requiredCapability={item.requiredCapability}>
                {item.usesStripe ? (
                  <StripeElements>{item.element}</StripeElements>
                ) : (
                  item.element
                )}
              </ProtectedRoute>
            }
            path={item.path}
          />
        ))}
        {/* Public: the flow creates or restarts the account, so it cannot require
            an app session. */}
        {onboardingRoute}
        <Route
          element={
            <Navigate to={signupEntryPath(ONBOARDING_BASE_PATH)} replace />
          }
          path={Path.Signup}
        />
        <Route
          element={
            <Navigate to={signupEntryPath(ONBOARDING_BASE_PATH)} replace />
          }
          path="/create-profile"
        />
        <Route element={<RootRedirect />} path="/" />
        <Route
          element={<PolicyPage type="privacy" />}
          path={Path.PrivacyPolicy}
        />
        <Route element={<PolicyPage type="terms" />} path={Path.Terms} />
        <Route
          element={<PolicyPage type="community" />}
          path={Path.Community}
        />
        <Route element={<DeleteAccountPage />} path={Path.DeleteAccount} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default Router;
